import { EventDetailsField } from "@tento-ui/components/event-details/event-details-field";
import { HtmlEditor } from "@tento-ui/components/html-editor";

export namespace EventDetailsFieldRichText {
  export function make(): EventDetailsField<HtmlEditor> {
    const $e = EventDetailsField.make()
      .assignStyles({
        padding: "0px",
      })
      .addPointerEvent<EventDetailsField>({
        onClick: () => {
          $editor.focusEditor();
        },
      });

    $e.onClickOutside = () => {
      $editor.blur();
    };

    const $editor = HtmlEditor.make();
    $editor.assignStyles({
      width: "100%",
      "--placeholder-size": "var(--small-size)",
      "--editor-padding": "13px 12px",
      "--max-height": "240px",
    });
    $e.appendChild($editor);

    return $e as unknown as EventDetailsField<HtmlEditor>;
  }
}
